/* tslint:disable */
/* eslint-disable */
/**
 * AgentAssistService
 * Agent Assist API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CallingIdentity } from './CallingIdentity';
import {
    CallingIdentityFromJSON,
    CallingIdentityFromJSONTyped,
    CallingIdentityToJSON,
} from './CallingIdentity';

/**
 * 
 * @export
 * @interface ReimportContactJobRequestContent
 */
export interface ReimportContactJobRequestContent {
    /**
     * 
     * @type {CallingIdentity}
     * @memberof ReimportContactJobRequestContent
     */
    callingIdentity: CallingIdentity;
}


/**
 * Check if a given object implements the ReimportContactJobRequestContent interface.
 */
export function instanceOfReimportContactJobRequestContent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "callingIdentity" in value;

    return isInstance;
}

export function ReimportContactJobRequestContentFromJSON(json: any): ReimportContactJobRequestContent {
    return ReimportContactJobRequestContentFromJSONTyped(json, false);
}

export function ReimportContactJobRequestContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReimportContactJobRequestContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'callingIdentity': CallingIdentityFromJSON(json['callingIdentity']),
    };
}

export function ReimportContactJobRequestContentToJSON(value?: ReimportContactJobRequestContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'callingIdentity': CallingIdentityToJSON(value.callingIdentity),
    };
}

